import { Avatar as AntAvatar } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { space, SpaceProps } from 'styled-system';

interface AvatarProps extends SpaceProps {
  avatar: string | null;
}

export const Avatar = styled('div')<AvatarProps>`
  ${space}
  width: 30px;
  height: 30px;
  background: ${({ avatar }) => `url('${avatar}'), url('')`};
  border-radius: 15px;
  background-size: 100% 100%;
`;

interface GAvatarProps extends SpaceProps {
  className?: string;
  src?: null | string;
  size?: 'large' | 'small' | 'default' | number;
  style?: React.CSSProperties;
}

export const bird =
  'data:image/svg+xml,<?xml version="1.0" encoding="utf-8"?>%0A<!-- Generator: Adobe Illustrator 16.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->%0A<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">%0A<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px"%0A%09 height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">%0A<g>%0A%09<rect y="-0.111" fill="%23DDDFE6" width="40" height="40"/>%0A</g>%0A<g>%0A%09<g>%0A%09%09<path fill="%23778199" d="M30.213,16.346c-0.002-0.012-0.002-0.027-0.005-0.038c-0.04-0.194-0.228-0.322-0.421-0.283v-0.002%0A%09%09%09l-0.008,0.002l0,0l0,0l-8.92,1.785c-0.387,0.077-0.764-0.174-0.842-0.562c-0.064-0.327,0.105-0.646,0.393-0.783l-0.003-0.003%0A%09%09%09v-0.001l7.812-3.909l0,0c0.106-0.057,0.172-0.179,0.146-0.305c-0.006-0.027-0.013-0.052-0.027-0.073l0,0%0A%09%09%09c-0.447-0.856-1.387-1.319-2.716-0.808l-12.85,5.266l0.002,0.005c-2.187,0.932-3.498,3.301-3.014,5.723%0A%09%09%09c0.477,2.375,2.516,4.035,4.833,4.123l0,0c0,0,2.677,0.201,6.613,0.131C25.628,26.53,31.249,23.065,30.213,16.346z"/>%0A%09%09<path fill="%23FFFFFF" d="M17.638,20.438c-0.799,0.22-1.628-0.251-1.849-1.051c-0.002-0.01-0.004-0.019-0.006-0.029l-0.002-0.011%0A%09%09%09c-0.002-0.002-0.004-0.003-0.005-0.007c-0.05-0.183-0.239-0.29-0.421-0.238c-0.182,0.05-0.289,0.238-0.238,0.421%0A%09%09%09c0,0.002,0,0.006,0,0.01l0.003,0.009c0.003,0.009,0.007,0.019,0.009,0.027c0.221,0.8-0.25,1.63-1.049,1.851%0A%09%09%09c-0.8,0.22-1.629-0.252-1.848-1.052c-0.221-0.799,0.251-1.627,1.049-1.848c0.488-0.133,1.006-0.014,1.389,0.319%0A%09%09%09c0.131-0.172,0.309-0.291,0.518-0.35c0.207-0.057,0.423-0.044,0.624,0.037c0.157-0.483,0.54-0.851,1.028-0.986%0A%09%09%09c0.799-0.219,1.627,0.251,1.848,1.051C18.908,19.389,18.437,20.218,17.638,20.438z M16.713,19.678%0A%09%09%09c0.216,0.164,0.496,0.22,0.756,0.149c0.461-0.129,0.734-0.608,0.606-1.069c-0.081-0.297-0.317-0.528-0.614-0.607%0A%09%09%09c-0.01,0.012-0.02,0.024-0.029,0.04C16.982,18.795,16.781,19.421,16.713,19.678z M13.139,20.646%0A%09%09%09c0.218,0.174,0.504,0.233,0.773,0.16c0.461-0.127,0.732-0.608,0.605-1.068c-0.084-0.308-0.33-0.542-0.643-0.615%0A%09%09%09c-0.01,0.017-0.022,0.034-0.035,0.051C13.405,19.771,13.207,20.393,13.139,20.646z"/>%0A%09</g>%0A</g>%0A</svg>';

const StyledAntAvatar = styled(AntAvatar)`
  margin-right: 9px;
  ${space}
`;

let failedSrc: Array<string | null | undefined> = [];

export const GAvatar: React.FC<GAvatarProps> = ({ src, children, ...others }) => {
  const [useName, setUseName] = useState(false);

  const handleError = () => {
    setUseName(true);
    failedSrc.push(src);
    return false;
  };

  if (!src || useName || failedSrc.includes(src)) {
    if (typeof children === 'string' && children.length > 0) {
      return <StyledAntAvatar {...others}>{children[0]}</StyledAntAvatar>;
    }
    return <StyledAntAvatar {...others} src={bird} />;
  }
  return <StyledAntAvatar {...others} src={src} onError={handleError} />;
};
